<!-- 智能制造 -->
<template>
  <div class="intmanu">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <div class="titleImage">
      <h3 class="h3">方案简介</h3>
      <div class="con width">
        <div class="conImg">
          <img src="../assets/images/u1447.png" alt srcset />
        </div>
        <div class="conImg">
          <img src="../assets/images/u1446.png" alt srcset />
        </div>
      </div>
    </div>
    <!-- 特点优势 -->
    <div class="trait">
      <h3 class="h3">特点优势</h3>
      <div class="con width">
        <div class="text">
          <p>通过本系统的实施，实现对生产业务的人员、设备、物料、生产过程、质量等全流程管控，提升资源利用率，提升生产效率，实现生产透明化。</p>
        </div>
        <div class="conItems">
          <div class="conitem" v-for="(item,i) in traitData" :key="i" :class="i%2!=0?'write':''">
            <h4>{{item.title}}</h4>
            <img :src="item.img" alt srcset />
            <p>{{item.p}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 系统架构 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img"></TitleImg>
    <!-- 直观效应 -->
    <TitleImg
      :title="titleOne.title"
      :image="titleOne.img"
      :bgimage="titleOne.bgimage"
      :wwidth="titleOne.wwidth"
    ></TitleImg>
    <!-- 提交方案咨询 -->
    <div class="subPlay">
      <el-button type="primary" icon="el-icon-s-order">提交方案咨询</el-button>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import TitleImg from '../components/TitleImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, TitleImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '智能制造解决方案',
        bgImg: require('../assets/images/u1439.png'),
        content:
          '打通信息孤岛，助力工厂实现智能制造借助云计算、智能手机、IoT设备，基于数据聚合、多角色协同、可视化分析、智能决策四大功能版块，用数据和算法帮助企业缩短生产周期、降低库存积压、提升产能利用率、透明化制造流程，实现数据驱动下的精益制造。',
        bl: true,
      },
      sceneCon: {
        title: '方案简介',
        img: require('../assets/images/jj.png'),
      },
      traitData: [
        {
          title: '全流程数字管控',
          img: require('../assets/images/u1456.png'),
          p:
            '由客户下单或销售导入订单开始，到计划和生产中的生产排程、生产过程数据管理、生产进度管控、工位分配，再到质量和仓储部门的原料耗用、过程质检、半成品成品入库等，最终实现销售出去全流程管控',
        },
        {
          title: '多系统设备集成',
          img: require('../assets/images/u1462.png'),
          p:
            '向上连通生产设备，对设备实时监控，对状态及时反馈，数据实时采集。向下与主流财务，ERP，SRM，CRM,OA等系统集成，标准接口，信息无缝对接',
        },
        {
          title: '可视化数据分析',
          img: require('../assets/images/u1468.png'),
          p:
            '通过多系统集成，汇集多维度数据，全面统计，智能分析，让复杂散乱的生产业务数据实现可视化展示，随时随地全面掌控工厂和公司运行状况',
        },
        {
          title: '多维度智能决策',
          img: require('../assets/images/u1474.png'),
          p:
            '通过多系统集成，汇集多维度数据，全面统计，智能分析，自动根据实时生产动态计算产能，实时进行智能生产排程，智能仓储和生产连动管理，实现智能规划库存等多维度实现智能决策',
        },
      ],
      titleImg: {
        title: '系统架构',
        img: require('../assets/images/u1478.png'),
      },
      titleOne: {
        title: '直观效应',
        img: require('../assets/images/one.png'),
        bgimage: require('../assets/images/u213.png'),
        wwidth: '12',
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.titleImage {
  background-color: rgba(242, 242, 242, 1);
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .con {
    display: flex;
    justify-content: center;
    align-items: center;
    .conImg {
      flex: 1;
      img {
        width: 440px;
        height: 440px;
      }
    }
    .conImg:last-child {
      img {
        width: 676px;
        height: 511px;
      }
    }
  }
}
.trait {
  background: url('../assets/images/u1438.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;

  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .con {
    .text {
      letter-spacing: 1px;
      line-height: 30px;
      text-indent: 2em;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      margin: 120px 0 800px auto;
      p {
        width: 680px;
        margin: 0 0 0 auto;
      }
    }
    .conItems {
      display: flex;
      width: 1040px;
      margin: 0 auto;
      .conitem {
        flex: 1;
        width: 245px;
        margin: 0 10px;
        border-radius: 4px;
        background-color: #fff;
        text-align: center;
        h4 {
          font-weight: 700;
          font-size: 20px;
        }
        img {
          width: 134px;
          height: 104px;
          margin: 60px auto;
        }
        p {
          line-height: 20px;
          text-align: left;
          padding: 0 20px 60px 20px;
        }
      }
      .write {
        background-color: rgba(73, 75, 90, 1);
        h4,
        p {
          color: #fff;
        }
      }
    }
  }
}
.subPlay {
  text-align: center;
  padding: 60px 0;
  background-color: #fff;
}
</style>
